import Cookies from 'js-cookie';

let CookieMsg = {
    init: () => {
        handleCookieMsg();
        handleBannerMsg();
        handleDialogMsg();
        sendCookie();
    }
}

const handleCookieMsg = () => {
    let cookieMsg =  $('[data-bind="cookiemessage"]'),
        cookieMsgSubmit = cookieMsg.find('[data-bind="submit"]'),
        cookieMsgShowMore = cookieMsg.find('[data-bind="learn-more"]'),
        cookieMsgShowLess = cookieMsg.find('[data-bind="show-less"]');

    cookieMsgSubmit.on('click', function(e) {
        e.stopPropagation();
        cookieMsg.addClass('hidden');
    });

    function infoToggle() {
        $('#learn-more-content').toggle();
        $("#default-cookie-content").toggle();
    }

    cookieMsgShowMore.add(cookieMsgShowLess).on('click', () => infoToggle());

    typeof Cookies.get('cookieconsent') === 'undefined' ? cookieMsg.removeClass('hidden') : cookieMsg.addClass('hidden');
}

const handleBannerMsg = () => {
    let bannerMsg =  $('[data-bind="bannermessage"]'),
        bannerMsgClose = bannerMsg.find('[data-bind="close"]'),
        navContainer = $('.nav-container'),
        headerBanner = $('.header-banner'),
        carouselBanner = $('.carousel-banner'),
        sectionHeader = $('.section-header'),
        sideBar = $('.nav-sidebar');

    bannerMsgClose.on('click', function(e) {
        e.stopPropagation();
        Cookies.set('bannermessage', 'accepted', {expires: 365});
        navContainer.addClass('no-banner');
        sideBar.removeClass('with-banner');
        sectionHeader.removeClass('section-header-with-banner');
        headerBanner.remove();
        carouselBanner.remove();
    });

    Cookies.get('bannermessage') === 'accepted' ? bannerMsg.remove() : '';

    if ($(".header-banner")[0] || $(".carousel-banner")[0]){
        navContainer.removeClass('no-banner');
        sectionHeader.addClass('section-header-with-banner');
    } else {
        sectionHeader.removeClass('section-header-with-banner');
    }

    navContainer.hasClass('no-banner') ? sideBar.removeClass('with-banner') : '';
}

const sendCookie = () => {
    let cookie = {
        necessaryCookies: $('.necessary-cookies:checked').val(),
        performanceAnalyticsCookies: $('.performance-analytics-cookies:checked').val(),
        advertisementTargetingCookies: $('.advertisement-targeting-cookies:checked').val(),
    }

    function updateCookieValues() {
        cookie.performanceAnalyticsCookies = $('.performance-analytics-cookies:checked').val();
        cookie.advertisementTargetingCookies = $('.advertisement-targeting-cookies:checked').val();
    }

    $('.cookie-checkbox').on('change', () => updateCookieValues());

    $('.cookie-compliance-form').on('submit', function (e) {
        e.stopImmediatePropagation();
        document.cookie = 'cookieconsent=' + JSON.stringify(cookie)
            + '; Expires=' + new Date(Date.now() + 12 * 30 * 60 * 60 * 24 * 1000).toUTCString()
            + '; Domain=' + getCookieDomain()
            + '; Path=/; SameSite=Strict; Secure';
        window.dataLayer = window.dataLayer || [];
        let consentUpdateEvent = copyOptOutValues(cookie, {
            'event': 'gtm_cookie_consent',
            'ad_storage': 'granted', // Default permissions
            'analytics_storage': 'granted' // Default permissions
        });
        window.dataLayer.push(consentUpdateEvent);

        return false;
    });
}

const handleDialogMsg = () => {
    let dialog = $('.dialog-modal'),
        dialogClose = $('[data-dialog-close]');

    dialog.each(function() {
        let cookieName = this.dataset.cookiename;

        Cookies.get(cookieName) ? this.remove() : this.show();
    });


    dialogClose.on('click', function() {
        let dialog = this.closest('.dialog-modal');
        dialog.dataset.cookiename && Cookies.set(dialog.dataset.cookiename, 'accepted', {expires: 365});
        dialog.remove();
    });
}

const copyOptOutValues = (cookiePreferences, consentSettings) => {
    // Disallow opt-out selections, they are present in localStorage only when allowed from CookieMsg module
    if (cookiePreferences.performanceAnalyticsCookies === undefined) {
        consentSettings.analytics_storage = 'denied';
    }
    if (cookiePreferences.advertisementTargetingCookies === undefined) {
        consentSettings.ad_storage = 'denied';
    }

    return consentSettings;
}

const getCookieDomain = () => {
    return location.hostname
        .replace('www.', '')
        .replace('test-app.', '')
        .replace('app.', '');
}

export default CookieMsg;
